import {DeepPartial} from 'utility-types';

import {PriceValue} from '../../../types/PriceValue';

export const isPriceFromWithVat = (price?: DeepPartial<PriceValue> | null) =>
  price?.fromWithVat !== undefined && price?.fromWithVat;
